import { MilestoneApi } from '../api-typings/projects/projects';
import { transformCurrency } from '../currency/currency.transformers';
import { Milestone } from './milestone.model';

export function transformMilestone(milestone: MilestoneApi): Milestone {
  return {
    // TODO fix the id thing - probably just change the api type;
    id: milestone.transaction_id || Math.random(),
    projectOwnerId: milestone.project_owner_id,
    bidderId: milestone.bidder_id,
    amount: milestone.amount,
    reason: milestone.reason,
    otherReason: milestone.other_reason,
    projectId: milestone.project_id,
    bidId: milestone.bid_id,
    currency: milestone.currency
      ? transformCurrency(milestone.currency)
      : undefined,
    isFromPrepaid: milestone.is_from_prepaid,
    status: milestone.status,
    disputeId: milestone.dispute_id,
    timeCreated: milestone.time_created,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/ko/webapp/src/app/@shared/datastore/milestone/milestone.transformers.ts